import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredNotification = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.27242C7.20436 2.27242 6.4413 2.60756 5.8787 3.20413C5.31609 3.80069 5.00002 4.6098 5.00002 5.45347C5.00002 7.77394 4.53027 9.31231 4.02677 10.2911C3.98111 10.3799 3.93528 10.4638 3.88963 10.5431H12.1104C12.0647 10.4638 12.0189 10.3799 11.9732 10.2911C11.4697 9.31231 11 7.77394 11 5.45347C11 4.6098 10.6839 3.80069 10.1213 3.20413C9.5587 2.60756 8.79564 2.27242 8 2.27242ZM13.7397 10.655C13.7393 10.6547 13.7387 10.6542 13.738 10.6536C13.7334 10.65 13.7227 10.6413 13.7067 10.6272C13.6748 10.599 13.6218 10.5489 13.5543 10.4734C13.4196 10.3227 13.2258 10.0688 13.0267 9.68181C12.6302 8.91103 12.2 7.58646 12.2 5.45347C12.2 4.27233 11.7575 3.13958 10.9698 2.30439C10.1822 1.4692 9.1139 1 8 1C6.8861 1 5.81782 1.4692 5.03017 2.30439C4.24253 3.13958 3.80003 4.27233 3.80003 5.45347C3.80003 7.58646 3.3698 8.91103 2.9733 9.68181C2.77423 10.0688 2.58038 10.3227 2.44572 10.4734C2.37824 10.5489 2.32521 10.599 2.29328 10.6272C2.2773 10.6413 2.26659 10.65 2.26197 10.6536C2.26125 10.6542 2.26068 10.6547 2.26026 10.655C2.04517 10.8117 1.94999 11.0982 2.02579 11.3637C2.10241 11.632 2.33564 11.8156 2.60004 11.8156H13.4C13.6644 11.8156 13.8976 11.632 13.9742 11.3637C14.05 11.0982 13.9548 10.8117 13.7397 10.655ZM2.26632 10.6506C2.26637 10.6506 2.26642 10.6506 2.26647 10.6505C2.26646 10.6505 2.26646 10.6505 2.26646 10.6505L2.26632 10.6506ZM6.69094 13.1667C6.98131 12.9974 7.34613 13.1098 7.50578 13.4177C7.55444 13.5115 7.62597 13.5898 7.71291 13.6443C7.79985 13.6988 7.899 13.7276 8 13.7276C8.101 13.7276 8.20015 13.6988 8.28709 13.6443C8.37403 13.5898 8.44556 13.5115 8.49422 13.4177C8.65387 13.1098 9.01869 12.9974 9.30906 13.1667C9.59944 13.336 9.70541 13.7228 9.54576 14.0307C9.39356 14.3242 9.16982 14.569 8.89791 14.7395C8.626 14.91 8.3159 15 8 15C7.6841 15 7.374 14.91 7.10209 14.7395C6.83018 14.569 6.60644 14.3242 6.45424 14.0307C6.29459 13.7228 6.40056 13.336 6.69094 13.1667Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredNotification)
const IconSvgColouredNotification = createIcon(
  ForwardRef,
  'SvgColouredNotification',
)
export default IconSvgColouredNotification
